import React, { useState, useEffect, useRef } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Image, Upload } from 'antd';
import Config from "@/config";
import {useCommonStore} from "@/store/useCommonStore";

const url = Config.ApiHost + "/api/v5/private/upload-image-manual";
const getBase64 = (file) =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
});

export default function ImageUpload({value, onChange, maxCount, initValue}, ref) {

    const user = useCommonStore.use.user();
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');

    // 用于显示在组件中的图片列表
    const [fileList, setFileList] = useState([]);
    useEffect(()=> {
        let result = [];
        if (Array.isArray(initValue)) {
            result = initValue.map((item) => ({
                url: Config.ApiHost + item.url,
                status: 'done',
                name: item.name,
            }))
        }
        setFileList( result);
    }, [initValue]);
    console.log('ImageUpload, value:', value, "initValue:", initValue, "fileList:",fileList);

    const handlePreview = async (file) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj);
        }
        setPreviewImage(file.url || file.preview);
        setPreviewOpen(true);
    };
    const handleChange = ({ file, fileList: list, event }) => {
        console.log("ImageUpload handleChange, file:", file, " list:", list);

        const newFileList = fileList.filter((item) => item.uid !==file.uid);
        //--- 上传成功的，保留服务端url
        if (file.status === 'done') {
            newFileList.push({
                ...file,
                urlRemote: file.response.data[0].url,
            });
        } else if (file.status === 'removed') {
            //--- 移除的：不加入列表中
        } else if (file.status === 'error') {
            //--- 出错的
            newFileList.push(file);
        } else {
            newFileList.push(file)
        }
        // console.log("newFileList", newFileList);
        setFileList(newFileList);
        // 用于保存为组件的值
        if (typeof(onChange) === 'function') {
            onChange(
                newFileList
                    .filter(item=>item.status === 'done')
                    .map((item) => ({
                        name: item.name,
                        url:  item.urlRemote,
                        "type": item.type,
                        size: item.size,
                    }))
            );
        }
    };

    const uploadButton = (
        <button
            style={{
                border: 0,
                background: 'none',
            }}
            type="button"
        >
            <PlusOutlined />
            <div
                style={{
                    marginTop: 8,
                }}
            >
                上传
            </div>
        </button>
    );

    const getExtraData = (file) => {
        // const suffix = file.name.slice(file.name.lastIndexOf('.'));
        // const filename = Date.now() + suffix;
        console.log(file);
        return {
            type: file.type,
            name: file.name,
        };
    }

    const headers = {
        'Accept':        'application/json',
    }
    if (user?.auth?.token && user?.auth?.name) {
        headers.Authorization = user?.auth?.name;
        headers.wsctoken = user?.auth?.token;
    }

    return (
        <>
            <Upload
                action={url}
                accept="image/*"
                name='file'
                listType="picture-card"
                fileList={fileList}
                onPreview={handlePreview}
                onChange={handleChange}
                data={getExtraData}
                method="POST"
                withCredentials={false}
                headers={headers}
            >
                {fileList.length >= Number(maxCount) ? null : uploadButton}
            </Upload>
            {previewImage && (
                <Image
                    wrapperStyle={{
                        display: 'none',
                    }}
                    preview={{
                        visible: previewOpen,
                        onVisibleChange: (visible) => setPreviewOpen(visible),
                        afterOpenChange: (visible) => !visible && setPreviewImage(''),
                    }}
                    src={previewImage}
                />
            )}
        </>
    );
}